<template>
   <div class="page-deliver-todo">
      <div class="pg-breadcrumb">
         <div class="breadcrumb-item em">派送專線</div>
         <div class="breadcrumb-item">待派送訂單</div>
      </div>
      <div class="card-block">
         <Form inline class="pg-form-inline">

            <FormItem>
               <!--<DatePicker class="no-suffix" type="date" size="small" :clearable="true"
                           placeholder="待派送訂單-開始日期" v-model="form.start_time" value-format="yyyy-MM-dd"
                           :editable="false" style='width: 100%;'>
               </DatePicker>-->
            </FormItem>
            <FormItem>选择日期</FormItem>
            <FormItem>
               <!--<DatePicker class="no-suffix" type="date" size="small" :clearable="true"
                           placeholder="待派送訂單-結束日期" v-model="form.end_time" value-format="yyyy-MM" :editable="false"
                           style='width: 100%;'>
               </DatePicker>-->
               <DatePicker type="month" class="no-suffix" placeholder="选择日期" v-model="form.end_time" :clearable="true" :editable="false" style="width: 100%;" />
            </FormItem>
         </Form>
         <Form inline class="pg-form-inline form-input-wrap">
            <FormItem>
               <label class="input-label">客戶電話</label>
               <Input size="small" v-model="form.user_phone" @keyup.enter.native="handleSearch()" clearable></Input>
            </FormItem>
            <FormItem>
               <div class="pg-btn-wrap">
                  <div class="pg-btn style1" @click="handleSearch">搜索</div>
                  <a target="_blank" class="pg-btn style2" @click="handleExport"
                     style="margin-left: 15px;">導出excel</a>
               </div>
            </FormItem>
         </Form>
      </div>

      <div class="card-block pd-bt">
         <Spin fix class="pg-sub-loading" v-if="isSubmiting">
            <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
            <div class="loading-text">Loading</div>
         </Spin>

         <Table size="small"
                border
                no-data-text="暫無數據"
                :columns="table.column"
                :row-class-name="rowClassName"
                :data="table.data">

            <!--<template slot-scope="{ row, index }" slot="status">

            </template>-->

            <!--<template slot-scope="{ row, index }" slot="action">
               <div class="pg-btn-wrap">
                  <div class="pg-btn style2">打印</div>
               </div>
            </template>-->
         </Table>

         <div class="pg-pagger">
            <Row>
               <Col span="11" class="pagger-left">
                  <div class="pagger-total">總共{{ totalCount }}條記錄</div>
               </Col>
               <Col span="13" class="pagger-right">
                  <!-- v-if="totalCount > curPageSize" -->
                  <div>
                     <div class="pagger-sizer">
                        <span>每頁</span>
                        <Select v-model="curPageSize" size="small" placeholder="數量"
                                @on-change="handlePageSizeChange">
                           <Option :value="10">10</Option>
                           <Option :value="20">20</Option>
                           <Option :value="30">30</Option>
                           <Option :value="40">40</Option>
                           <Option :value="50">50</Option>
                        </Select>
                     </div>

                     <div class="pagger-elevator">
                        <span>跳轉</span>
                        <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                               @on-enter="handlePageEnter"/>
                     </div>

                     <Page size="small"
                           :current="pageIndex"
                           :page-size="curPageSize"
                           :total="totalCount"
                           @on-change="handlePageChange">
                     </Page>
                  </div>
               </Col>
            </Row>
         </div>
      </div>
   </div>
</template>

<script>
import axios from 'axios';

export default {
   data() {
      return {
         pageIndex: 1,   //页码
         curPageSize: 10,    //一页数量
         totalCount: 1, //总条数
         pageInput: '',  //输入的页码
         deliveryareaList: [], //派送專線
         deliverybuildingList: [], //派送專線大廈
         pickAdmin: [],
         form: {
            add_id: '', //關聯地址ID
            store_id: '',  //關聯專線id
            odd_number: '', //快遞單號
            user_name: '', //客户名稱
            user_phone: '', //客户電話
            order_status: 1, //订单派送状态0待派送,无动作,3派送中,5派送完毕,待用户确认
            start_time: '', //開始预约时间
            end_time: '', //結束预约时间
            order_reserve_time: true, //预约时间，true是开始，false是关闭
         },
         isSubmiting: false,
         // isLoading: true,
         exportLink: '', //导出地址
         table: {
            column: [
               /*{
                  title: '操作',
                  align: 'center',
                  sortable: true,
                  slot: 'action',
                  minWidth: 150
               },*/
               {
                  title: '电话',
                  key: 'recipient_phone',
                  align: 'center',
                  sortable: true,
                  minWidth: 150
               },
               {
                  title: '名称',
                  key: 'recipient_contacts',
                  align: 'center',
                  sortable: true,
                  width: 100
               },
               {
                  title: '单号',
                  key: 'odd_numbers',
                  align: 'center',
                  sortable: true,
                  width: 250
               },
               {
                  title: '长',
                  key: 'long',
                  align: 'center',
                  sortable: true,
                  minWidth: 150
               },

               {
                  title: '宽',
                  key: 'wide',
                  align: 'center',
                  sortable: true,
                  minWidth: 100
               },
               {
                  title: '高',
                  key: 'height',
                  align: 'center',
                  sortable: true,
                  minWidth: 100
               },
               {
                  title: '重量',
                  key: 'weight',
                  align: 'center',
                  sortable: true,
                  minWidth: 100
               },
               {
                  title: '时间',
                  key: 'pick_time',
                  align: 'center',
                  sortable: true,
                  minWidth: 100
               },

            ],
            data: []
         }
      };
   },

   mounted() {
      this.getList();
   },
   activated() {
      this.getList();
   },
   methods: {

      rowClassName(row, index) {
         if (row.order_number_status === 0) {
            return 'row-red';
         } else if (row.order_number_status === 1) {
            return 'row-yellow';
         } else if (row.order_number_status === 2) {
            return 'row-green';
         }
         return '';
      },
      formatDate(datetime) {
         if (!datetime) return '';

         let dateTime = new Date(datetime);
         let year = dateTime.getFullYear();
         let month = dateTime.getMonth() + 1;
         let date = dateTime.getDate();
         let hour = dateTime.getHours();
         let minute = dateTime.getMinutes();
         let second = dateTime.getSeconds();
         let milliseconds = dateTime.getMilliseconds();
         return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)}`;
      },
      formatNum(num) {
         return num < 10 ? '0' + num : num;
      },
      getList() {
         let form = this.form;
         this.table.data = []
         this.isSubmiting = true;
         this.$Rq.requestAuth({
            url: this.$Api.getBtbList,
            method: 'get',
            data: {
               user_phone: form.user_phone,
               year: this.formatDate(form.end_time).slice(0,4),
               month: this.formatDate(form.end_time).slice(5,7),
               offset: (this.pageIndex - 1) * this.curPageSize,
               limit: this.curPageSize,
            }
         }).then((res) => {
            console.log(res)
            this.isSubmiting = false;
            if (res.code == 0) {
               this.table.data = res.data.data || []
               this.totalCount = res.data.count || 0;
            }
         }).catch((err) => {
            this.isSubmiting = false;
         });
      },

      handleSearch() {
         this.pageIndex = 1;
         this.getList();
      },

      handleExport() {
         let form = this.form;
         if(form.end_time == ''){
         	this.$Utils.showTipInfo("請選擇日期");
         	return false
         }

         let params = {
            user_phone: form.user_phone,
            year: this.formatDate(form.end_time).slice(0,4),
            month: this.formatDate(form.end_time).slice(5,7),
         };

         this.$Rq.requestAuth({
            url: this.$Api.exportExcl,
            method: 'get',
            data: params,
            headers: {
               responseType: 'blob'
            }
         }).then(res => {
            let blob = new Blob([res], {type: "text/html;charset=utf-8"})
            let urlPdf = window.URL.createObjectURL(blob);
            let newWindow = window.open(urlPdf, false);
            if (window.print) {
               newWindow.print();
            }
            newWindow.addEventListener('afterprint', function () {
               newWindow.document.close();
               window.URL.revokeObjectURL(urlPdf)
               newWindow.close()
            })
         })
         this.getList();
      },
      handlePageSizeChange(value) {
         this.pageIndex = 1;
         this.getList();
      },
      handlePageInput() {
         let value = ('' + this.pageInput).replace(/\D/g, '');
         let pageCount = Math.ceil(this.totalCount / this.curPageSize);
         if (value > pageCount) {
            value = pageCount;
         }
         this.pageInput = value;
      },
      handlePageEnter() {
         if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
         if (this.pageInput == 0) {
            this.pageInput = 1;
         }
         this.pageInput = parseInt(this.pageInput);
         this.pageIndex = this.pageInput;
         this.getList();
      },
      handlePageChange(value) {
         this.pageIndex = value;
         this.getList();
      }
   }
};
</script>

<style>
.ivu-table .row-red td {
   background-color: rgb(255, 235, 235);
   color: #FFFFFF;
}

.ivu-table .row-yellow td {
   background-color: rgb(255, 243, 219);
   color: #FFFFFF;
}

.ivu-table .row-green td {
   background-color: rgb(229, 255, 236);
   color: #FFFFFF;
}

.el-table__row--level-1 {
   background-color: rgba(238, 238, 238, 0.33) !important;
}
</style>

<style lang="scss" scoped>
@import "btbList.scss";
</style>
